import { useState } from "react";
import { toast } from "sonner";
import { Trash2, ExternalLink } from "lucide-react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { api } from "@/lib/api";
import DataTable from "@/admin/DataTable";
import Uploader from "@/admin/Uploader";
import { useFetch, KIND, Loading, ErrorBox, fmtDate, fmtSize, mediaUrl, apiError } from "@/admin/ui";

export default function Library() {
  const { data, setData, error } = useFetch("/admin/files");
  const [del, setDel] = useState(null);
  if (error) return <ErrorBox />;
  if (!data) return <Loading />;
  const remove = async () => {
    try { await api.delete(`/admin/files/${del.id}`); setData(data.filter((f) => f.id !== del.id)); toast.success("Archivo eliminado."); }
    catch (e) { toast.error(apiError(e)); } finally { setDel(null); }
  };
  const columns = [
    { key: "name", label: "Archivo", render: (r) => <div><b>{r.name}</b>{r.used_in.length > 0 && <div className="adm-sub">En: {r.used_in.join(", ")}</div>}</div> },
    { key: "kind", label: "Tipo", render: (r) => <span className="adm-badge mute">{KIND[r.kind] || r.kind}</span> },
    { key: "size", label: "Tamaño", num: true, render: (r) => fmtSize(r.size) },
    { key: "created_at", label: "Fecha", render: (r) => <span className="adm-sub">{fmtDate(r.created_at, true)}</span> },
    { key: "act", label: "", render: (r) => (
      <div className="adm-row" style={{ flexWrap: "nowrap", gap: ".4rem" }}>
        <a href={mediaUrl(r.url)} target="_blank" rel="noreferrer" className="adm-btn sm" aria-label="Abrir" data-testid={`admin-file-open-${r.id}`}><ExternalLink size={14} /></a>
        <button className="adm-btn sm danger" onClick={() => setDel(r)} data-testid={`admin-file-delete-${r.id}`}><Trash2 size={14} /> Eliminar</button>
      </div>) },
  ];
  return (
    <div data-testid="admin-library">
      <div style={{ marginBottom: "1rem" }}><Uploader onUploaded={(f) => setData([f, ...data])} testid="admin-library-uploader" /></div>
      <DataTable columns={columns} rows={data} testid="admin-files-table" emptyText="La biblioteca está vacía. Sube tu primer archivo." />
      <AlertDialog open={!!del} onOpenChange={(o) => !o && setDel(null)}>
        <AlertDialogContent className="bg-white text-[#10151C]">
          <AlertDialogHeader>
            <AlertDialogTitle>Eliminar archivo</AlertDialogTitle>
            <AlertDialogDescription>Se quitará «{del?.name}» de la biblioteca y de los módulos donde se use.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="admin-file-delete-cancel">Cancelar</AlertDialogCancel>
            <AlertDialogAction onClick={remove} className="bg-[#B91C1C] hover:bg-[#991B1B]" data-testid="admin-file-delete-confirm">Eliminar</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}
